"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_sqs_1 = require("@aws-sdk/client-sqs");
class SQS {
    constructor(queueUrl, paramsOverride) {
        this.queueUrl = queueUrl;
        this.sqsClient = SQS.createSQSClient(paramsOverride);
    }
    static createSQSClient(paramsOverride) {
        return new client_sqs_1.SQSClient(paramsOverride || {});
    }
    static async createQueue(name, messageRetentionPeriod = '300', paramsOverride) {
        const input = {
            QueueName: name,
            Attributes: { MessageRetentionPeriod: messageRetentionPeriod }
        };
        const response = await SQS.createSQSClient(paramsOverride).send(new client_sqs_1.CreateQueueCommand(input));
        if (!response.QueueUrl) {
            throw new Error('Queue URL is empty.');
        }
        return new SQS(response.QueueUrl);
    }
    async getQueueAttributes(attributeNames) {
        const input = { QueueUrl: this.queueUrl, AttributeNames: attributeNames };
        const response = await this.sqsClient.send(new client_sqs_1.GetQueueAttributesCommand(input));
        return response.Attributes;
    }
    async getArn() {
        const arnKey = 'QueueArn';
        const attributes = await this.getQueueAttributes([arnKey]);
        if (!attributes || !attributes[arnKey]) {
            throw new Error(`Missing either Attributes or ${arnKey} attribute in the response.`);
        }
        return attributes[arnKey];
    }
    async setQueueAttributes(attributes) {
        const input = { QueueUrl: this.queueUrl, Attributes: attributes };
        return this.sqsClient.send(new client_sqs_1.SetQueueAttributesCommand(input));
    }
    async setPolicy(policy) {
        await this.setQueueAttributes({ Policy: policy });
    }
    async sendMessage(message, paramsOverride) {
        const input = { QueueUrl: this.queueUrl, MessageBody: message, ...paramsOverride };
        return this.sqsClient.send(new client_sqs_1.SendMessageCommand(input));
    }
    async receiveMessage(waitTimeSeconds, paramsOverride) {
        const input = {
            QueueUrl: this.queueUrl,
            WaitTimeSeconds: waitTimeSeconds,
            ...paramsOverride
        };
        return this.sqsClient.send(new client_sqs_1.ReceiveMessageCommand(input));
    }
    async deleteQueue() {
        const input = { QueueUrl: this.queueUrl };
        return this.sqsClient.send(new client_sqs_1.DeleteQueueCommand(input));
    }
}
exports.default = SQS;
